import {CardDetails} from "@bounce/shared/enums";
import {BaseQueryOptions, BaseUseQueryResult, useBaseQuery} from "@bounce/shared/requests";
import {AxiosResponse} from "axios";
import {axiosConsumerAppInstance} from "~/api/ConsumerApiManager";

type Variables = {
  payment_plan_id: string | undefined;
  accountId: string;
};

type Data = CardDetails[];

export const getPaymentMethods = async (variables: Variables): Promise<Data> => {
  const result = await axiosConsumerAppInstance.get<Data, AxiosResponse<Data>>(
    `/payment_methods/${variables.payment_plan_id}`
  );
  return result.data;
};

export const useGetPaymentMethods = (
  variables: Variables,
  options?: BaseQueryOptions<Data, Variables>
): BaseUseQueryResult<Data> => {
  return useBaseQuery<Data, Variables>(["payment-methods", variables.accountId], getPaymentMethods, variables, options);
};
